import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allCreditCards: [],
  bookingCredicards: [],
  transactionRecordStoreStatus: {},
  creditCardDetail: {},
  creditcards: [],
  creditcardLoading: true,
  creditCardDetailLoading: true,
};

const creditCardSlice = createSlice({
  name: "creditCard",
  initialState: initialState,
  reducers: {
    setCreditCardDetailLoading(state, action) {
      state.creditCardDetailLoading = action.payload.creditCardDetailLoading;
    },
    setCreditCardLoading(state, action) {
      state.creditcardLoading = action.payload.creditcardLoading;
    },
    getAllCreditCards(state, action) {
      state.allCreditCards = action.payload.allCreditCards;
    },
    getCreditCards(state, action) {
      state.creditcards = action.payload.creditcards;
    },
    getCreditCardDetail(state, action) {
      state.creditCardDetail = action.payload.creditCardDetail;
    },
    clearTransactionRecordStoreStatus(state, action) {
      state.transactionRecordStoreStatus = {};
    },
    setBookingCreditCards(state, action) {
      state.bookingCredicards = action.payload;
    },
    setTransactionRecordStoreStatus(state, action) {
      state.transactionRecordStoreStatus[action.payload.txnId] = false;
    },
    setTransactionRecordStoreStatustrue(state, action) {
      state.transactionRecordStoreStatus[action.payload.txnId] = true;
    },
  },
});

export const {
  setCreditCardDetailLoading,
  setCreditCardLoading,
  getAllCreditCards,
  setBookingCreditCards,
  setTransactionRecordStoreStatus,
  setTransactionRecordStoreStatustrue,
  clearTransactionRecordStoreStatus,
  getCreditCardDetail,
  getCreditCards,
} = creditCardSlice.actions;

export const creditCardSliceReducer = creditCardSlice.reducer;
